import { gql } from "@apollo/client";

export const PLAYLIST_FRAGMENT = gql`
  fragment PlaylistFragment on PlaylistV2 {
    id
    name
    thumbnailImageUrl
  }
`;

export const CLASS_FRAGMENT = gql`
  fragment ClassFragment on StudioClass {
    id
    title
    thumbnailImageUrl
    instructor {
      name
    }
  }
`;

export const GET_FEATURED_CLASSES = gql`
  query GetFeaturedClasses {
    getFeaturedClasses {
      id
      displayOrder
      studioClass {
        ...ClassFragment
      }
    }
  }
  ${CLASS_FRAGMENT}
`;

export const GET_FEATURED_PLAYLISTS = gql`
  query GetFeaturedPlaylists {
    getFeaturedPlaylists {
      id
      displayOrder
      playlist {
        ...PlaylistFragment
      }
    }
  }
  ${PLAYLIST_FRAGMENT}
`;

export const ADD_FEATURED_PLAYLIST = gql`
  mutation AddFeaturedPlaylist($id: ID!) {
    adminAddFeaturedPlaylist(playlistId: $id) {
      playlist {
        ...PlaylistFragment
      }
    }
  }
  ${PLAYLIST_FRAGMENT}
`;

export const ADD_FEATURED_STUDIO_CLASS = gql`
  mutation AddFeaturedStudioClass($id: ID!) {
    adminAddFeaturedStudioClass(id: $id) {
      studioClass {
        ...ClassFragment
      }
    }
  }
  ${CLASS_FRAGMENT}
`;

export const REMOVE_FEATURED_PLAYLIST = gql`
  mutation RemoveFeaturedPlaylist($id: ID!) {
    adminRemoveFeaturedPlaylist(id: $id)
  }
`;

export const REMOVE_FEATURED_STUDIO_CLASS = gql`
  mutation RemoveFeaturedStudioClass($id: ID!) {
    adminRemoveFeaturedStudioClass(id: $id)
  }
`;

export const UPDATE_FEATURED_PLAYLISTS_ORDER = gql`
  mutation UpdateFeaturedPlaylistsOrder($items: [String!]!) {
    adminUpdateFeaturedPlaylistsOrder(items: $items)
  }
`;

export const UPDATE_FEATURED_CLASSES_ORDER = gql`
  mutation UpdateFeaturedClassesOrder($items: [String!]!) {
    adminUpdateFeaturedClassesOrder(items: $items)
  }
`;
